import React, { useRef, useEffect } from 'react';
import { motion } from 'framer-motion';
import Webcam from 'react-webcam';
import { Box } from '@mui/material';

import {
  LooksGoodButton,
} from './TakePhoto.styles';

const TakePhoto = ({ onCapture, onCancel }) => {
  const webcamRef = useRef(null);

  const handleTakePhoto = () => {
    if (webcamRef.current) {
      const screenshot = webcamRef.current.getScreenshot();
      if (screenshot) {
        onCapture(screenshot); // Devuelve la foto capturada al padre
      }
    }
  };

  useEffect(() => {
    const webcamNode = webcamRef.current;

    return () => {
      if (webcamNode?.video?.srcObject) {
        const tracks = webcamNode.video.srcObject.getTracks();
        tracks.forEach((track) => track.stop());
      }
    };
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginTop: '2rem',
        justifyContent: 'center',
        height: '100%',
        width: '100%',
      }}
    >
      <Webcam
        audio={false}
        ref={webcamRef}
        screenshotFormat="image/jpeg"
        style={{
          width: '85%',
          maxWidth: '350px',
          borderRadius: '10px',
          objectFit: 'cover',
        }}
      />
      <Box display="flex" gap="8px" marginTop="40px">
        <LooksGoodButton variant="contained" onClick={handleTakePhoto}>
          Take Photo
        </LooksGoodButton>
        <LooksGoodButton variant="outlined" color="secondary" onClick={onCancel}>
          Cancel
        </LooksGoodButton>
      </Box>
    </motion.div>
  );
};

export default TakePhoto;